import React from 'react';

import Icon from '../Icon/Icon';

const AemPauseModeIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <rect
                x='12.9375'
                y='6.9375'
                width='22.125'
                height='34.125'
                rx='11.0625'
                fill='#00D1D2'
                stroke='#393E44'
                strokeWidth='1.875'
            />
            <rect x='18' y='17.25' width='3' height='13.5' rx='1.5' fill='#393E44' />
            <rect x='27' y='17.25' width='3' height='13.5' rx='1.5' fill='#393E44' />
        </Icon>
    );
};

export default AemPauseModeIcon;
